import { useState } from "react";
import type { ImpersonationState } from "../../hooks/useAuth";
import { useImpersonation } from "../../hooks/useImpersonation";
import styles from "./ImpersonationBanner.module.css";

type Props = { state: ImpersonationState };

// Persistent top-of-viewport banner shown whenever an admin is in a
// "view as" session. Distinctive colour (warning wash) so it's
// impossible to forget — accidentally taking actions in an
// impersonated session would be confusing.
export const ImpersonationBanner = ({ state }: Props): JSX.Element => {
  const { stop } = useImpersonation();
  const [busy, setBusy] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const handleStop = async (): Promise<void> => {
    setBusy(true);
    setError(null);
    const result = await stop();
    if (result.ok) {
      window.location.href = "/dashboard/admin/users";
      return;
    }
    setError(result.message);
    setBusy(false);
  };

  return (
    <div className={styles.banner} role="status">
      <span className={styles.label}>
        Viewing as <strong>{state.viewingAs}</strong> · admin{" "}
        <span className={styles.dim}>{state.originalAdminEmail}</span>
      </span>
      <div className={styles.actions}>
        {error && <span className={styles.error}>{error}</span>}
        <button
          type="button"
          className={styles.exitBtn}
          onClick={() => void handleStop()}
          disabled={busy}
        >
          {busy ? "Exiting…" : "Exit impersonation"}
        </button>
      </div>
    </div>
  );
};
